<section id="landing-screen" class="section">
  <div class="section--container">
    <div class="row">
      <div class="col-lg-6">
        <h1 class="d-sm-block text-primary text-ultra m-b-2">FAQ</h1>
        <p class="fs-1-25">
          Make the best out of Adscore<br />
          with our frequently asked questions
        </p>
      </div>
    </div>
  </div>
</section>

<div id="homepage-content" [attr.tiles-visible]="openSection ? null : ''">
  <app-content-divider [filled]="true"></app-content-divider>
  <ng-container [ngSwitch]="true">
    <section class="section" id="qa-list" *ngSwitchCase="!openSection">
      <div class="section--container">
        <app-section-tile
          *ngFor="let section of sections"
          [section]="section"
          (click)="showSection(section, true)"
        ></app-section-tile>
      </div>
    </section>
    <section id="sections" *ngSwitchCase="!!(openSection && !openQuestion)">
      <aside id="sections-list">
        <app-content-divider class="m-b-0-5"></app-content-divider>
        <ng-container *ngFor="let s of sections">
          <span
            [ngClass]="{
              'cursor-pointer': true,
              'lh-1-8': true,
              'p-0': true,
              'm-b-0-5': true,
              'category-name': true,
              'text-primary': openSection!.id === s.id
            }"
            [attr.active]="openSection!.id === s.id ? '' : null"
            id="{{ s.id }}"
            (click)="showSection(s, true)"
            [innerHTML]="s.title"
          >
            <ng-container *ngIf="openSection!.id === s.id">&gt;</ng-container>
          </span>
          <br />
        </ng-container>
        <app-content-divider class="m-t-0-5"></app-content-divider>
      </aside>
      <div id="section-questions">
        <h2 class="text-primary text-heavy m-b-2" [innerHTML]="openSection!.title"></h2>
        <div class="m-t-1 p-1 background-neutral-lightest" *ngFor="let q of openSection!.questions; let index = index">
          <a
            class="text-secondary fs-1 text-bold"
            (click)="showAnswer(q)"
            href="{{ '/faq/' + q.slug }}"
            [innerHTML]="q.text"
          ></a>
        </div>
        <h4 aria-level="3" class="cursor-pointer text-bold nav-link-faq m-t-1 m-b-4 go-back-link" (click)="showFaq()">
          <fa-icon [icon]="faArrowLeft"></fa-icon>
          <span class="back-to-faq-link">GO BACK</span>
        </h4>
      </div>
    </section>
    <section id="answer" *ngSwitchCase="!!openQuestion">
      <div class="inner">
        <div class="spacer"></div>
        <h4 class="cursor-pointer text-bold nav-link-faq">
          <span (click)="showFaq()" id="back-to-faq-link">FAQ</span>
          &gt;
          <span (click)="showSection(openSection!)" [innerHTML]="openSection!.title"></span>
        </h4>
        <h2 class="text-primary text-heavy header" [innerHTML]="openQuestion!.text"></h2>
        <app-content-divider></app-content-divider>
        <p id="answer-content" [innerHTML]="openQuestion!.answer" #answerContent></p>
        <ng-container *ngIf="openQuestion!.slug === 'about-us'">
          <div class="section">
            <div class="section--container">
              <div class="row justify-content-center">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-md-6 md-offset-2">
                      <iframe
                        #map
                        width="100%"
                        height="230"
                        frameborder="0"
                        scrolling="no"
                        marginheight="0"
                        marginwidth="0"
                        style="border: 1px solid black"
                      ></iframe>
                    </div>
                    <div class="col-md-4 pl-md-5 mt-4 mt-md-0">
                      <h5>Contact details:</h5>
                      <p>
                        <strong>Adscore Technologies DMCC</strong><br />
                        Office 1906, Jumeirah Business Center 5,<br />
                        Cluster W, Jumeirah Lake Towers,<br />
                        P.O. Box 282060<br />
                        Dubai, United Arab Emirates<br />
                      </p>
                      <p>
                        <!-- The e-mail below will only be shown if Adscore Validation passes successfully -->
                        <span *ngIf="gotContactData"
                          >Email — <a href="mailto:office@adscore.com">office&#64;adscore.com</a><br
                        /></span>
                        <span class="label">Phone</span> — <a href="tel:+97142428305"><u>+97142428305</u></a
                        ><br />
                        DUNS — 864345707<br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <h4 class="cursor-pointer text-bold nav-link-faq go-back-link" (click)="showSection(openSection!, true)">
          <fa-icon [icon]="faArrowLeft"></fa-icon>
          <span class="back-to-faq-link">GO BACK</span>
        </h4>
      </div>
    </section>
  </ng-container>
</div>
